<script lang="ts" setup>
const props = defineProps<{
  user: Author
  followStatus?: number
  highlight?: string
}>()
</script>

<template>
  <div :title="user.name" class="myz-author">
    <div class="myz-author__info">
      <div class="myz-author__avatar">
        <MAvatar :id="user.id" :size="62" :src="user.avatar" link />
        <n-popover v-if="user.user_auth" trigger="hover">
          <template #trigger>
            <img
              v-if="user.user_auth"
              :src="`https://resource.mfuns.net/imgs/auth/${user.user_auth.type}.svg`"
              alt="auth"
              class="myz-author__auth-badge"
              :style="{
                width: 12,
                height: 12
              }"
            />
          </template>
          <div>{{ user.user_auth?.name }} {{ user.user_auth?.desc }}</div>
        </n-popover>
      </div>
      <m-link
        :to="`/member/${user.id}`"
        class="myz-author__name highlight"
        :style="{
          color: user.name_color
        }"
      >
        <div class="myz-author__info-detail">
          <div class="myz-author__info-name">
            <span
              class="myz-author__name-text"
              v-html="highlight || user.name"
            ></span>
            <m-badge size="sm" :badges="user.badges" />
          </div>
          <m-text type="secondary">
            {{ user.info }}
          </m-text>
          <m-text type="secondary"> 粉丝数：{{ user.fans }} </m-text>
        </div>
      </m-link>
    </div>

    <div class="myz-author__action">
      <m-follow-button :id="user.id" style="flex: 1" :status="followStatus" />
      <m-message-button :id="user.id" style="flex: 1" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.myz-author {
  display: flex;
  flex-direction: column;
  gap: 12px;
  &__info {
    display: flex;
    align-items: center;
    &-detail {
      margin-left: 12px;
      display: flex;
      flex-direction: column;
    }
    &-name {
      display: flex;
    }
  }
  &__action {
    width: 100%;
    display: flex;
    gap: 6px;
  }
  &__avatar {
    position: relative;
    flex-shrink: 0;
  }
  &__name {
    height: 100%;
    &-text {
      font-size: 16px;
    }
  }
  &__auth-badge {
    position: absolute;
    background: #fff;
    border-radius: 50%;
    outline: 2px solid #fff;
    bottom: 0;
    right: 0;
    z-index: 100;
    height: 18px;
    width: 18px;
  }
}
</style>
